import './Slider.2e63426cd1ef5236ea2e9e6530173ae6.css';
export default {"wrapper":"_wrapper_10k51_1"};